import { takeLatest, select, put } from 'redux-saga/effects';
import size from 'lodash/size';

import * as resolvedList from '../complaintResolvedList';
import * as unresolvedList from '../complaintUnResolvedList';
import * as resolveComplaint from '../resolveComplaint';
import { actions as complaintDetailsActions } from '../complaintDetails';
import { actions as complaintCountersActions } from '../complaintCounters';
import {
  selectUnResolvedList,
  selectResolvedList,
  makeSelectComplaintsCounter,
} from '../selectors';

function* handleResolvedComplaint(action) {
  const FIRST_REQUEST_LIMIT = 10;
  const { payload } = action;
  const { status, id } = payload;

  if (status === 'unresolved') {
    yield put(complaintDetailsActions.update(payload));
  } else {
    const unresolvedCounter = yield select(
      makeSelectComplaintsCounter('unresolved'),
    );
    const unresolved = yield select(selectUnResolvedList);
    const resolved = yield select(selectResolvedList);

    yield put(unresolvedList.actions.removeComplaint({ id }));
    yield put(complaintCountersActions.updateUnresolved());

    if (unresolvedCounter >= FIRST_REQUEST_LIMIT) {
      yield put(
        unresolvedList.paginationActions.send({
          limit: 1,
          offset: size(unresolved),
          status: 'unresolved',
        }),
      );
    }

    yield put(
      resolvedList.actions.send({
        status: 'resolved',
        silent: true,
        limit:
          size(resolved) < FIRST_REQUEST_LIMIT
            ? FIRST_REQUEST_LIMIT
            : size(resolved),
        offset: 0,
      }),
    );
  }
}

export default function* resolveComplaintWatcher() {
  yield takeLatest([resolveComplaint.consts.SUCCEED], handleResolvedComplaint);
}



// WEBPACK FOOTER //
// ./src/redux/complaints/watchers/resolveComplaintWatcher.js